import { Box, Paper, TextField, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Actions } from '../../Redux/Reducer/rootReducer';
import { fetchAnnouncement, singleAnnouncement } from '../../Redux/selectors';
import { Announcements, AnnouncementsPriority, AnnouncementStatus, UserType } from '../../Types/UnitFeatureTypes';
import LexicalRichText from '../CommonComponents/LexicalRichText';
import { useAuth } from '../../context/authContext';
import Editor from '../TextEditor/Editor';
import { Campaign } from '@mui/icons-material';

const AnnouncementView: React.FC = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user} = useAuth();
    const IS_MANAGER = user?.type === UserType.MANAGER;
    const currentRequestData = useSelector(singleAnnouncement) as Announcements;
    const [announcementData, setAnnouncementData] = React.useState<Announcements>({
        id: 0,
        title: '',
        description: '',
        status: AnnouncementStatus.DRAFT,
        seen_by: 0,
        created_on: '',
        priority: AnnouncementsPriority.HIGH,
    });
    

    const getPriortyColor = (priority: AnnouncementsPriority) => {
        switch (priority) {
            case AnnouncementsPriority.HIGH:
                return 'red';
            case AnnouncementsPriority.MEDIUM:
                return 'orange';
            case AnnouncementsPriority.LOW:
                return 'green';
            default:
                return 'black';
        }
    };

    useEffect(() => {
        dispatch(Actions.fetchAnnouncement.announcementActions.request(
        { id: location?.state?.id }
        ));
    }, []);

    useEffect(() => {
        if (currentRequestData && Array.isArray(currentRequestData) && currentRequestData.length > 0) {
            setAnnouncementData({
                id: currentRequestData[0].id,
                title: currentRequestData[0].title,
                description: currentRequestData[0].description,
                status: currentRequestData[0].status,
                seen_by: currentRequestData[0].seen_by,
                created_on: currentRequestData[0].created_on,
                priority: currentRequestData[0].priority,
            });
        } else if (currentRequestData && !Array.isArray(currentRequestData)) {
            setAnnouncementData({
                id: currentRequestData.id,
                title: currentRequestData.title,
                description: currentRequestData.description,
                status: currentRequestData.status,
                seen_by: currentRequestData.seen_by,
                created_on: currentRequestData.created_on,
                priority: currentRequestData.priority,
            })
        }
    }, [currentRequestData]);

    return (
        <>
        <Paper elevation={3} sx={{mb: 2, padding: 2, borderRadius: 3, display: 'flex', justifyContent: 'space-between'}}>
            <Box color='primary.main' sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', }}>
                <Campaign sx={{mr:1, height: 40, width: 40}} />
                <Typography variant="h5">Announcement</Typography>
            </Box>
        </Paper>
        <Paper elevation={5} sx={{padding: 6, m: 1}}>
            <Box marginBottom={3}>
            <TextField
                fullWidth
                variant="standard"
                value={announcementData.title}
                InputProps={{
                    disableUnderline: true,
                    style: {
                        fontSize: '2rem',
                        fontWeight: 'bold',
                    },
                    readOnly: true,
                }}
            />
            <Box marginTop={2} display="flex" justifyContent="flex-end">
                <Typography variant="subtitle1" color="textSecondary">{new Date(announcementData.created_on).toDateString()}</Typography>
            </Box>
            {/* <LexicalRichText
                value={announcementData.description}
                isReadOnly={true}
                placeholder=""
                error={false}
                onChange={() => {}}
            /> */}
            <Editor
                value={announcementData.description}
                isReadOnly={true}
                placeholder=""
                error={false}
                onChange={() => {}}
            />
            </Box>

            <Paper elevation={2} sx={{padding: 1, borderRadius: 3, display: 'flex', justifyContent: 'space-between'}}>
                <Typography sx={{color: getPriortyColor(announcementData.priority)}} variant="subtitle1">Priority: {announcementData.priority}</Typography>
                {IS_MANAGER && <Typography variant="subtitle1" color="textSecondary">Seen By: {announcementData.seen_by}</Typography>}
            </Paper>
        </Paper>
        </>
    );
}

export default AnnouncementView;